// TrainingCourses.js
import React from "react";
import "./training.scss";
import { useMediaQuery } from "react-responsive";
import CarouselSlider from "../../slider/Slider";
import { StaticImage } from "gatsby-plugin-image";
import { Link as GatsbyLink } from "gatsby";

const TrainingCourses = () => {
  const [isClient, setIsClient] = React.useState(false);
  React.useEffect(() => setIsClient(true), []);

  const isTablet = useMediaQuery({ query: "(max-width: 768px)" });

  const CardAutodesk = (
    <div className="trainingBox">
      <div className="trainingBoxIcon AutodeskIcon">
        <StaticImage src="../../../assets/images/Autodesk_Logo.png" alt="Autodesk logo" />
      </div>
      <h3 className="trainingTitle">Autodesk <span>Courses</span></h3>
      <div className="trainingButtonWrapper">
        <GatsbyLink className="trainingLink" to="/courses-autodesk" aria-label="Explore Autodesk BIM Courses">
          Explore <span className="btnArrow"><StaticImage src="../../../assets/images/arrow.png" alt="" role="presentation" /></span>
        </GatsbyLink>
      </div>
    </div>
  );

  const CardBentley = (
    <div className="trainingBox">
      <div className="trainingBoxIcon BentleyIcon">
        <StaticImage src="../../../assets/images/BentleyLOGO_BLK_complete.png" alt="Bentley logo" />
      </div>
      <h3 className="trainingTitle">Bentley Systems <span>Courses</span></h3>
      <div className="trainingButtonWrapper">
        <GatsbyLink className="trainingLink" to="/courses-bentley" aria-label="Explore Bentley BIM Courses">
          Explore <span className="btnArrow"><StaticImage src="../../../assets/images/arrow.png" alt="" role="presentation" /></span>
        </GatsbyLink>
      </div>
    </div>
  );

  const CardCerts = (
    <div className="trainingBox">
      <div className="trainingBoxIcon skillsfutureIcon">
        <StaticImage
          src="../../../assets/images/my-skils-future.png"
          alt="SkillsFuture logo"
        />
      </div>
      <h3 className="trainingTitle">SkillsFuture <span>Courses</span></h3>
      <div className="trainingButtonWrapper">
        <GatsbyLink className="trainingLink" to="/courses-skillsfuture" aria-label="Explore SkillsFuture Courses">
          Explore <span className="btnArrow"><StaticImage src="../../../assets/images/arrow.png" alt="" role="presentation" /></span>
        </GatsbyLink>
      </div>
    </div>
  );

  return (
    <div className="trainingSection">
      <div className="container">
        <div className="trainingSectionTitle">
          <h2 className="trainingTitle">See Training Courses from Different Categories</h2>
          <p className="trainingContent">
            All BIM courses are taught by Industry Practitioners. Technical training and in-person instruction inclusive
          </p>
        </div>

        {/* Desktop/grid is the SSR-safe default */}
        {(!isClient || !isTablet) && (
          <div className="testiInner" key="desktop">
            <div className="traningBoxWrapper">
              {CardAutodesk}
              {CardBentley}
              {CardCerts}
            </div>
          </div>
        )}

        {/* Mobile/carousel renders only on client */}
        {isClient && isTablet && (
          <div className="testiInner" key="mobile">
            <div className="traningBoxWrapper">
              <CarouselSlider slidesToShow={1} slidesToScroll={1} showSlideDots={false}>
                {CardAutodesk}
                {CardBentley}
                {CardCerts}
              </CarouselSlider>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrainingCourses;
